export class LookupsFilterModel {
    pageSize: number;
    pageNumber: number;
    searchText?: string;
    totalCount: number;
    ParentId?: number;
}
